import React from 'react';
import PropTypes from 'prop-types';

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';

import { camelize } from '../../library/strings';

class ReportMailing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      modified: false,
      cron_condition: (this.props.reportMailing.cron != '0 9 * * *' && this.props.reportMailing.cron != '0 9 * * 1' &&
      this.props.reportMailing.cron != '0 9 1 * *' && this.props.reportMailing.cron != '0 9,17 * * *' &&
      this.props.reportMailing.cron),
      reportMailing: {
        ...this.props.reportMailing,
        userId: this.props.reportMailing.userId || '',
        cron: this.props.reportMailing.cron || '0 2 * * *',
        reportId: this.props.reportMailing.report.id || '',
        status: this.props.reportMailing.status
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeCronInput = this.changeCronInput.bind(this);

    this.form = React.createRef();
  }

  getCurrentElementValue(element) {
    if (element.name.match(/\[\]$/)) {
      return [
        ...document.querySelectorAll(
            `[name="${element.name}"]:checked, [type="hidden"][name="${
              element.name
            }"]`
        ),
      ].map((element) => element.value);
    }

    if (element.type === 'checkbox') {
      return element.checked;
    }

    return element.value;
  }

  hasErrors() {
    return Object.values(this.state.errors).filter((value) => value).length > 0;
  }

  handleChange(event) {
    const target = event.target;
    const field = target.name.replace(
        /report_mailing\[(.+?)\](\[\])?/,
        '$1'
    );
    const value = this.getCurrentElementValue(target);

    this.setState((state) => ({
      errors: { ...state.errors, [camelize(field)]: !target.validity.valid },
      modified: true,
      reportMailing: {
        ...state.reportMailing,
        [camelize(field)]: value,
      },
    }));
  }

  changeCronInput(event) {
    const target = event.target;
    this.setState((state) => ({
      cron_condition: target.checked
    }));
    // if(target.checked) {

    //   document.querySelector('input[name="know_cron"]').setAttribute('checked', 'checked');
    //   document.querySelector('input[name="know_cron"]').checked = true;
    //   document.querySelector('.input[name="report_mailing[cron]"]').style.display = 'block';
    //   document.querySelector('.cron_input').style.display = 'block';
    //   document.querySelector('select[name="report_mailing[cron]"]').style.display = 'none';
    //   document.querySelector('.cron_select').style.display = 'none';
    // } else {
    //   document.querySelector('input[name="know_cron"]').removeAttribute('checked');
    //   document.querySelector('input[name="know_cron"]').checked = false;
    //   document.querySelector('select[name="report_mailing[cron]"]').style.display = 'block';
    //   document.querySelector('.cron_select').style.display = 'block';
    //   document.querySelector('input[name="report_mailing[cron]"]').style.display = 'none';
    //   document.querySelector('.cron_input').style.display = 'none';
    // }
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.state.isSubmiting) {
      return;
    }

    this.setState({ isSubmiting: true }, () => {
      const method = this.state.reportMailing.id ? 'PATCH' : 'POST';
      fetch(
        this.state.reportMailing.id
          ? `/office/reports/${this.state.reportMailing.report.id}/report_mailings/${this.state.reportMailing.id}.json`
          : `/office/reports/${this.state.reportMailing.report.id}/report_mailings.json`,
        {
          body: new FormData(this.form.current),
          credentials: 'same-origin',
          headers: { 'X-CSRF-Token': Rails.csrfToken() },
          method: method,
        }
      )
          .then(function(response) {
            if (response.status >= 200 && response.status < 300) {
              return response.json();
            } else {
              const error = new Error(response.statusText);
              error.response = response;
              throw error;
            }
          })
          .then((data) => {
            this.setState(
                { isSubmiting: false, modified: false, priceListMailing: data },
                () => {
                  if (method === 'POST') {
                    Turbolinks.visit(`/office/report_mailings/${data.id}/edit`);
                  }
                  Turbolinks.visit('/office/reports');
                }
            );
          })
          .catch((error) => {
            this.setState({ isSubmiting: false });
            alert(
                'Произошла ошибка при попытке сохранения рассылки отчёта.'
            );
          });
    });
  }

  render() {
    return (
      <form
        id="report_mailing"
        ref={this.form}
        onSubmit={this.handleSubmit}
      >
        <input
          type="hidden"
          name="report_mailing[report_id]"
          value={this.state.reportMailing.reportId}
        />
        <div className="field">
          <label className="label">Получатель</label>

          <div className="control">
            <div className="select">
              <select
                name="report_mailing[user_id]"
                value={this.state.reportMailing.userId}
                onChange={this.handleChange}
              >
                <option value="">Выберите сотрудника</option>
                {this.props.users.map((data, index) => (
                  <option key={index} value={data.id}>{data.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="field">
          <label className="label">Расписание (в формате cron)</label>
          <div className="control">
            <label className="checkbox">
              <input
                name="know_cron"
                type="checkbox"
                value="1"
                checked={this.state.cron_condition}
                onChange={this.changeCronInput}
              />{' '}
              Я знаю формат cron
            </label>
          </div>
          <div className="control cron_select" style={this.state.cron_condition ? {display: 'none'} : {display: 'block'}}>
            <div className="select">
              <select
                name="report_mailing[cron]"
                value={this.state.reportMailing.cron}
                onChange={this.handleChange}
                style={this.state.cron_condition ? {display: 'none'} : {display: 'block'}}
              >
                <option value="">Выберите периодичность рассылки</option>
                <option value='0 9 * * *'>Каждый день в 09:00</option>
                <option value='0 9,17 * * *'>Каждый день в 09:00 и 17:00</option>
                <option value='0 9 * * 1'>Каждый понедельник в 09:00</option>
                <option value='0 9 1 * *'>Каждое первое число месяца в 09:00</option>
              </select>
            </div>
          </div>

          <div className="control cron_input" style={this.state.cron_condition ? {display: 'block'} : {display: 'none'}}>
            <input
              className={`input ${this.state.errors.cron && 'is-danger'}`}
              name="report_mailing[cron]"
              required
              type="text"
              style={this.state.cron_condition ? {display: 'block'} : {display: 'none'}}
              value={this.state.reportMailing.cron || ''}
              onChange={this.handleChange}
            />
          </div>
        </div>

        <div className="field">
          <label className="label">Статус</label>
          <div className="control">
            <div className="select">
              <select
                name="report_mailing[status]"
                value={this.state.reportMailing.status}
                onChange={this.handleChange}
              >
                <option value='paused'>Рассылка приостановлена</option>
                <option value='active'>Рассылка активна</option>
              </select>
            </div>
          </div>
        </div>

        <div className="field is-grouped">
          <div className="control">
            <button
              className={`button is-primary ${this.state.isSubmiting &&
                'is-loading'}`}
              disabled={
                !this.state.modified ||
                this.hasErrors() ||
                this.state.isSubmiting
              }
              type="submit"
            >
              {this.state.modified &&
                (this.state.reportMailing.id
                  ? 'Сохранить изменения'
                  : 'Добавить подписку')}
              {!this.state.modified && 'Изменения сохранены'}
            </button>
          </div>
          <div className="control">
            <a className="button is-text" href="/office/reports">
              назад ко всем отчётам
            </a>
          </div>
        </div>
      </form>
    );
  }
}

ReportMailing.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object),
  reportMailing: PropTypes.object,
  report: PropTypes.object
};

export default ReportMailing;
